import { t } from "@lingui/macro";

import tmxCoin from "img/bg_coin_tmx.png";
import tlpCoin from "img/bg_coin_tlp.png";
import IcTmxPool from "img/ic_tmx_40.svg?react";
import IcTlpPool from "img/ic_tlp_card.svg?react";

import { PoolCard } from "./PoolCard";
import { useHistory } from "react-router-dom";

export function PoolCards() {
  const history = useHistory();

  const goToBuyTlp = () => {
    history.push("/buy_tlp");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const goToEarn = () => {
    history.push("/earn");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const gmxAprForGmxPercentage = 1000;
  const tlpAprForPercentage = 500;
  return (
    <>
      <PoolCard
        name="TMX"
        apr={gmxAprForGmxPercentage}
        description={t`Stake for rewards and governance rights`}
        iconComponent={IcTmxPool}
        coinImage={tmxCoin}
        onClick={goToEarn}
      />
      <PoolCard
        name="TLP"
        apr={tlpAprForPercentage}
        description={t`Steady returns without management`}
        iconComponent={IcTlpPool}
        iconSizeClass="size-46"
        coinImage={tlpCoin}
        onClick={goToBuyTlp}
      />
    </>
  );
}
